import { withInstall } from '@tw-element/utils'
import Calendar from './src/calendar.vue'

export const TwCalendar = withInstall(Calendar)
export default TwCalendar

export * from './src/calendar'
